export const envConfig = {
    formalServer: process.env.NODE_ENV === 'production' ? 'https://server.cottongame.com' : 'http://192.168.0.119:9099',
    remoteSVNServiceUrl: 'http://8.130.32.232:9001',
    svnIp: '8.130.32.232',
    storageServiceUrl: process.env.NODE_ENV === 'production' ? 'https://server.cottongame.com' : 'http://192.168.0.119:9099',
    testServer: 'https://server.cottongame.com',
    imServer: process.env.NODE_ENV === 'production' ? 'wss://server.cottongame.com/im/ws' : 'ws://192.168.0.119:9099/im/ws'
}
